import { render, staticRenderFns } from "./Defaults.vue?vue&type=template&id=1ba75a8c&scoped=true&"
import script from "./Defaults.vue?vue&type=script&lang=js&"
export * from "./Defaults.vue?vue&type=script&lang=js&"
import style0 from "./Defaults.vue?vue&type=style&index=0&id=1ba75a8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba75a8c",
  null
  
)

export default component.exports